import React, {Component} from "react"
import {Button, Container, Divider, Form, Header, Icon, Loader, Modal, Popup, Radio} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {getLocalization, interpolateString, parseMultilineString, parseSingleUnderlinedWordInString} from "../utils/localization";
import {
    checkIsOpenEnrollment,
    checkIsVerified,
    findEmployerContribution,
    formatMoneyAmount,
    getBenAdminGreetingName,
    getEnrollmentTimezone,
    getNumberOfDeductions,
    getSpouseEligibilityString,
    getStepProps,
    handleSaveUserProgress,
    HEALTH_PLAN_DETAILS_ROUTE,
    INCOME_ROUTE,
    isAIG,
    isAnsel,
    isRenaissance,
    languages,
    registerEmailRecommendation,
    registerPrintRecommendation,
    stringTemplate,
    TELL_US_ABOUT_YOU_ROUTE,
    truncTwoDec,
    uiFlowBenAdmin,
} from "../utils/common"
import {isRenaissanceLouisiana} from "../utils/renaissanceLouisiana";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import Steps from "./steps/steps";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import {setCatastrophicCoverage, setCostPerOption, setCoverageOption, setFetchPlanRecommendation, setModerateCoverage, setPlanContribAndCost, setPlanCoverageSelectedAndRecommended, setSevereCoverage} from "../actions/userActions";
import {debounce} from "throttle-debounce";
import Footer from "./footer";
import moment from "moment";
import 'moment-timezone';
import IDontWantCoverageModal from "./iDontWantCoverageModal";
import {buildRiderDescription, getChronicRiderLabel, getMaternityRiderLabel, getMentalRiderLabel} from "../utils/riders";
import {ClickableText, CustomDivider, CustomEmailInput, CustomGrid, CustomModalHeader, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import PlanWarningsBanner from "./planWarningsBanner";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {show as showToast} from "../actions/toastActions";
import AdditionalRidersRows from "./additionalRidersRows";
import {PersonalizePlanRequest, ScheduleEmailRecommendationRequest, SubmitPlanDetailsRequest} from "../services/types";
import {getPersonalizePlan, scheduleEmailRecommendation, submitPlanDetails} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    const {contractInfo, openEnrollment, ratedClass, riderLabels, eligibility: {domesticPartnerEligible, civilUnionEligible}} = initialData;
    const {moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected} = user;
    const moderateCS = !!moderateCoverageSelected ? moderateCoverageSelected : null;
    const severeCS = !!severeCoverageSelected ? severeCoverageSelected : null;
    const catastrophicCS = !!catastrophicCoverageSelected ? catastrophicCoverageSelected : null;

    const contractTerms = ratedClass?.contractTerms || {};
    const additionalChronic = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
    const additionalMental = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
    const additionalMaternity = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;
    const hasRiders = !!additionalChronic || !!additionalMental || !!additionalMaternity;

    const {enrollmentStartDate, enrollmentEndDate} = openEnrollment;
    const start = moment(enrollmentStartDate);
    const end = moment(enrollmentEndDate);
    const isOpenEnrollment = checkIsOpenEnrollment(start, end, getEnrollmentTimezone(initialData));

    return {
        ...ownProps,
        contractInfo: contractInfo,
        additionalChronic,
        additionalMental,
        additionalMaternity,
        hasRiders,
        isOpenEnrollment,
        civilUnionEligible,
        domesticPartnerEligible,
        openEnrollmentStarts: start.format(isRenaissance() ? "MMMM D, YYYY" : "MMMM, Do YYYY"),
        moderateIncrements: (!!initialData && !!initialData.increments && initialData.increments.moderate) || [],
        severeIncrements: (!!initialData && !!initialData.increments && initialData.increments.severe) || [],
        catastrophicIncrements: (!!initialData && !!initialData.increments && initialData.increments.catastrophic) || [],
        coverageOptions: initialData.coverageOptions,
        costPerOptions: initialData.costPerOptions,
        token: initialData.token,
        coverageOption: user.coverageOption,
        costPerOption: user.costPerOption,
        moderateCoverageSelected: moderateCS,
        severeCoverageSelected: severeCS,
        catastrophicCoverageSelected: catastrophicCS,
        moderateCoverageRecommended: user.moderateCoverageRecommended,
        severeCoverageRecommended: user.severeCoverageRecommended,
        catastrophicCoverageRecommended: user.catastrophicCoverageRecommended,
        user: user,
        initialData, benAdmin,
        isBenAdmin: initialData.uiFlow === uiFlowBenAdmin,
        lang: user.lang,
        employerContribution: !!user.employerContribution ? user.employerContribution : "-",
        cost: (!!user.cost || user.cost === 0) ? user.cost : "-",
        recommendationSkipped: !!user.recommendationSkipped,
        riderLabels,
    }
};

class PlanChoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            loading: false,
            loadingPersonalize: false,
            submitPlanLoading: false,
            displayInformationAboutCategoriesModal: false,
            displaySeeWhyWeChoseThisAmountsModal: false,
            displayCaptureEmailModal: false,
            capturedEmail: '',
            emailValidationError: null,
            displayDontWantCoverageModal: false,
            userModifiedData: false,
            submittingEmailRecommendation: false,
        };

        this.debouncedPersonalizePlan = debounce(500, () => this.personalizePlan());
    }

    async componentDidMount() {
        const {initialData, benAdmin, user, coverageOption, coverageOptions, costPerOptions, recommendationSkipped, dispatch} = this.props;
        const {uiFlow, employerContribution} = initialData;

        checkIsVerified(user, benAdmin, uiFlow, this.props);

        if (user.fetchPlanRecommendation) {
            const ec = findEmployerContribution(coverageOption, coverageOptions, employerContribution);
            dispatch(setPlanContribAndCost(truncTwoDec(ec), 0));

            if (recommendationSkipped) {
                await this.handleSkipRecommendation(initialData, costPerOptions);
            } else {
                await this.submitInitialPlanDetails();
                await this.personalizePlan();
            }
        }

        dispatch(setPrevRoute(recommendationSkipped ? HEALTH_PLAN_DETAILS_ROUTE : INCOME_ROUTE));
        this.buildSteps();
    }

    async handleSkipRecommendation(initialData, costPerOptions) {
        const {dispatch} = this.props;
        const {payrollFrequencySelected, payrollFrequencyMonthly} = initialData;
        const payrollMethodValue = payrollFrequencySelected === payrollFrequencyMonthly ? 'Month' : 'Paycheck';
        const costPerOption = costPerOptions.filter(cpo => cpo.value === payrollMethodValue)[0].id;
        dispatch(setCostPerOption(costPerOption));
        const filteredCoverOptions = this.getFilteredCoverOptions();
        const deletes = this.alterDependentInfoBasedOnCoverage(filteredCoverOptions[0].value);
        await dispatch(setCoverageOption(filteredCoverOptions[0].value, deletes.deleteChildren, deletes.deleteSpouse));

        const {moderateIncrements, severeIncrements, catastrophicIncrements} = this.props;
        const m = moderateIncrements[0];
        const s = severeIncrements[0];
        const c = catastrophicIncrements[0];
        const translated = this.translateAmountToSliderIdx(m, s, c);
        dispatch(setPlanCoverageSelectedAndRecommended(
            null, translated.moderateRecommendation,
            null, translated.severeRecommendation,
            null, translated.catastrophicRecommendation,
        ));
        await this.personalizePlan(filteredCoverOptions[0].value, costPerOption, m, s, c);
        this.setState({
            loading: false,
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    alterDependentInfoBasedOnCoverage = (coverageOptionId) => {
        const {coverageOptions} = this.props;
        const option = coverageOptions.filter((c)=>c.value === coverageOptionId)[0];
        let deleteChildren;
        let deleteSpouse;
        switch(option.value){
            case 'employee':
                deleteChildren = true;
                deleteSpouse = true;
                break;
            case 'spouse':
                deleteChildren = true;
                deleteSpouse = false;
                break;
            case 'child':
                deleteChildren = false;
                deleteSpouse = true;
                break;
            default:
                deleteChildren = false;
                deleteSpouse = false;
        }
        return {deleteChildren, deleteSpouse};
    }

    translateSliderSelectionToAmount = () => {
        const {moderateIncrements, severeIncrements, catastrophicIncrements, moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected} = this.props;
        return {
            moderateCoverageSelected: moderateIncrements[moderateCoverageSelected-1],
            severeCoverageSelected: severeIncrements[severeCoverageSelected-1],
            catastrophicCoverageSelected: catastrophicIncrements[catastrophicCoverageSelected-1],
        }
    }

    translateAmountToSliderIdx = ( moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected ) => {
        const {moderateIncrements, severeIncrements, catastrophicIncrements, } = this.props;

        const getSliderIdx = (increments, amount) => {
            let sliderIdx = 1;
            increments.forEach((e, idx) => {
                if(e === amount){
                    sliderIdx = idx + 1;
                }
            })
            return sliderIdx;
        }

        return {
            moderateRecommendation: getSliderIdx(moderateIncrements, moderateCoverageSelected),
            severeRecommendation: getSliderIdx(severeIncrements, severeCoverageSelected),
            catastrophicRecommendation: getSliderIdx(catastrophicIncrements, catastrophicCoverageSelected),
        }
    }

    personalizePlan = async (forcedCoverageOption, forcedCostPerOpt, moderate, severe, catastrophic) => {
        this.setState({loadingPersonalize: true});
        try {
            const {token, additionalChronic, additionalMental, additionalMaternity, coverageOption, costPerOption, costPerOptions, initialData, isBenAdmin, user} = this.props;
            const {userModifiedData} = this.state;
            const selectedCostPerOptId = forcedCostPerOpt || costPerOption
            const selectedCostPerOpt = costPerOptions.find(c => c.id === selectedCostPerOptId)
            const payrollFreq = selectedCostPerOpt.value === 'Month' ? initialData.payrollFrequencyMonthly : initialData.payrollFrequencySelected;
            let coverageOpt = coverageOption;
            if(!!forcedCoverageOption){
                coverageOpt = forcedCoverageOption;
            }
            const translatedAmounts = this.translateSliderSelectionToAmount();
            let moderateBenefit = !!translatedAmounts.moderateCoverageSelected? translatedAmounts.moderateCoverageSelected: 0;
            let severeBenefit = !!translatedAmounts.severeCoverageSelected? translatedAmounts.severeCoverageSelected: 0;
            let catastrophicBenefit = !!translatedAmounts.catastrophicCoverageSelected? translatedAmounts.catastrophicCoverageSelected: 0;
            if(!!moderate){
                moderateBenefit = moderate;
                severeBenefit = severe;
                catastrophicBenefit = catastrophic;
            }
            let ageAtPolicyEffectiveDate = initialData.ageAtPolicyEffectiveDate;
            if(isBenAdmin){
                ageAtPolicyEffectiveDate = moment(initialData.policy.polEDate, 'YYYY-MM-DD').diff(moment(user.birthdate, 'MM/DD/YYYY'), 'years');
            }
            const request = new PersonalizePlanRequest({
                familyTierValue: coverageOpt,
                moderateBenefit: moderateBenefit,
                severeBenefit: severeBenefit,
                catastrophicBenefit: catastrophicBenefit,
                quoteInfo: initialData.quoteInfo,
                mentalBenefit: additionalMental,
                chronicBenefit: additionalChronic,
                maternityBenefit: additionalMaternity,
                ageAtPolicyEffectiveDate: ageAtPolicyEffectiveDate,
                employerContribution: initialData.employerContribution,
                token,
                presets: initialData.presets,
                payrollFrequencySelected: payrollFreq,
                userModifiedData,
                planOffering: initialData.contractInfo.planOffering,
                ratedClassRates: initialData.ratedClass.ratedClassRates,
            })
            let result = await getPersonalizePlan(request);
            if (!!result && !!result.data) {
                const data = result.data;
                const cost = !!data.costChoice ? data.costChoice : 0.0;
                const ec = data.contribChoice? data.contribChoice: 0.0;
                this.props.dispatch(setPlanContribAndCost(truncTwoDec(ec), truncTwoDec(cost)))
            }
            this.setState({loadingPersonalize: false});
        } catch (e) {
            console.log(e);
            this.setState({loadingPersonalize: false})
        }
    }

    submitInitialPlanDetails = async () => {
        this.setState({loading: true});
        try {
            const {user, token, coverageOption, initialData, coverageOptions, costPerOptions, isBenAdmin} = this.props;
            if(user.highDeductibleInfo === null || user.leftoverMoney === null){
                this.setState({loading: false});
                return;
            }
            let ageAtPolicyEffectiveDate = initialData.ageAtPolicyEffectiveDate;
            if(isBenAdmin){
                ageAtPolicyEffectiveDate = moment(initialData.policy.polEDate, 'YYYY-MM-DD').diff(moment(user.birthdate, 'MM/DD/YYYY'), 'years');
            }
            const request = new SubmitPlanDetailsRequest({
                token,
                maritalStatusId: user.maritalStatus,
                dependentsId: user.dependents,
                copayId: user.typicallyPayInfo,
                highDeductibleInfoId: user.highDeductibleInfo,
                leftoverMoneyId: user.leftoverMoney,
                ageAtPolicyEffectiveDate,
                payrollFrequencySelected: initialData.payrollFrequencySelected,
            })
            let result = await submitPlanDetails(request);
            if (!!result && !!result.data) {
                const data = result.data;
                const moderateRecommendation    = (!!data && !!data.choice && data.choice.moderateBenefit) || 0;
                const severeRecommendation      = (!!data && !!data.choice && data.choice.severeBenefit) || 0;
                const catastrophicRecommendation= (!!data && !!data.choice && data.choice.catastrophicBenefit) || 0;

                const translated = this.translateAmountToSliderIdx(moderateRecommendation, severeRecommendation, catastrophicRecommendation);
                const moderateCoverageSelected = translated.moderateRecommendation;
                const severeCoverageSelected = translated.severeRecommendation;
                const catastrophicCoverageSelected = translated.catastrophicRecommendation;
                this.props.dispatch(setPlanCoverageSelectedAndRecommended(
                    moderateRecommendation, moderateCoverageSelected,
                    severeRecommendation, severeCoverageSelected,
                    catastrophicRecommendation, catastrophicCoverageSelected,
                ))

                const isMonthly = initialData.payrollFrequencySelected === initialData.payrollFrequencyMonthly;
                let costPerOption = costPerOptions.filter(cpo => cpo.value === 'Paycheck')[0].id
                if(isMonthly){
                    costPerOption = costPerOptions.filter(cpo => cpo.value === 'Month')[0].id
                }
                this.props.dispatch(setCostPerOption(costPerOption));

                let recommendedOption = data.familyTierValue;
                const deletes = this.alterDependentInfoBasedOnCoverage(recommendedOption);
                this.props.dispatch(setCoverageOption(recommendedOption, deletes.deleteChildren, deletes.deleteSpouse));

                const cost = !!data && !!data.choice && !!data.choice.cost ? data.choice.cost : 0;
                const ec = findEmployerContribution(coverageOption, coverageOptions, initialData.employerContribution);
                this.props.dispatch(setPlanContribAndCost(truncTwoDec(ec), truncTwoDec(cost)))
                this.setState({loading: false});
            } else {
                this.setState({loading: false});
            }
        } catch (e) {
            console.error(e);
            this.setState({loading: false})
        }
    }

    doSendEmailRecommendation = async () => {
        const {capturedEmail} = this.state;
        if (capturedEmail.length === 0) {
            return;
        }
        registerEmailRecommendation(this.props.initialData.token);
        this.setState({submittingEmailRecommendation: true});

        const {
            benAdmin, cost, employerContribution, additionalChronic, additionalMental, additionalMaternity, costPerOptions, costPerOption,
            coverageOption, coverageOptions, isBenAdmin, user, openEnrollmentStarts, initialData, lang, riderLabels
        } = this.props;

        const localization = getLocalization(lang);
        const strings = localization.plan;
        const localizationEng = getLocalization(languages.ENGLISH);
        const engStrings = localizationEng.plan;

        try {
            const coverageOptionLabel = coverageOptions.filter(co => co.value === coverageOption)[0];
            const translatedAmounts = this.translateSliderSelectionToAmount();
            const payFrequency = (!!costPerOptions && costPerOptions.filter(cpo => cpo.id === costPerOption)[0].value).toLowerCase() || '';
            const isMonthly = payFrequency.toLowerCase() === 'month';
            let payFrequencyTranslated = strings.paycheck.toLowerCase();
            if(isMonthly){
                payFrequencyTranslated = strings.monthly.toLowerCase();
            }
            let coverageOptionLabelTranslated = coverageOptionLabel.text;
            switch(coverageOptionLabelTranslated){
                case(engStrings.coverOpt1):{
                    coverageOptionLabelTranslated = strings.coverOpt1;
                    break;
                }
                case(engStrings.coverOpt2):{
                    coverageOptionLabelTranslated = strings.coverOpt2;
                    break;
                }
                case(engStrings.coverOpt3):{
                    coverageOptionLabelTranslated = strings.coverOpt3;
                    break;
                }
                case(engStrings.coverOpt4):{
                    coverageOptionLabelTranslated = strings.coverOpt4;
                    break;
                }
                default:
                return false;
            }

            let firstName = user.firstName;
            if(isBenAdmin){
                firstName = getBenAdminGreetingName(benAdmin, initialData.distributionChannel);
            }

            const {yourBrellaPlanAlsoIncludes} = localization;
            const {
                chronicDetails1, chronicDetails2, chronicDetailsAmount,
                mentalDetails1, mentalDetails2, mentalDetailsAmount,
                maternityDetails1, maternityDetails2,  maternityDetailsAmount
            } = yourBrellaPlanAlsoIncludes;

            const chronicTitle = getChronicRiderLabel(yourBrellaPlanAlsoIncludes, riderLabels);
            const chronicDescription = buildRiderDescription(chronicDetails1, chronicDetailsAmount, chronicDetails2, chronicTitle);

            const mentalTitle = getMentalRiderLabel(yourBrellaPlanAlsoIncludes, riderLabels);
            const mentalDescription = buildRiderDescription(mentalDetails1, mentalDetailsAmount, mentalDetails2, mentalTitle);

            const maternityTitle = getMaternityRiderLabel(yourBrellaPlanAlsoIncludes, riderLabels);
            const maternityDescription = buildRiderDescription(maternityDetails1, maternityDetailsAmount, maternityDetails2, maternityTitle);

            const payload = new ScheduleEmailRecommendationRequest({
                firstName: firstName,
                moderateRecommendation: formatMoneyAmount(translatedAmounts.moderateCoverageSelected),
                severeRecommendation: formatMoneyAmount(translatedAmounts.severeCoverageSelected),
                catastrophicRecommendation: formatMoneyAmount(translatedAmounts.catastrophicCoverageSelected),
                chronic: formatMoneyAmount(additionalChronic),
                mental: formatMoneyAmount(additionalMental),
                maternity: formatMoneyAmount(additionalMaternity),
                employerContribution: formatMoneyAmount(employerContribution),
                yourTotalCost: formatMoneyAmount(parseFloat(cost)),
                payFrequency: payFrequencyTranslated,
                mailTo: capturedEmail,
                iWantToCover: coverageOptionLabelTranslated,
                uiFlow: initialData.uiFlow,
                language: lang,
                openEnrollmentStarts: openEnrollmentStarts,
                groupType: initialData.contractInfo.groupType,
                chronicTitle,
                chronicDescription,
                mentalTitle,
                mentalDescription,
                maternityTitle,
                maternityDescription
            })

            await scheduleEmailRecommendation(payload)
            this.props.dispatch(showToast({
                type: 'success',
                message: strings.emailSubmitted
            }));
        } catch (e) {
            console.error(e);
            this.props.dispatch(showToast({
                type: 'error',
                message: strings.submitEmailErrorMessage
            }));
        } finally {
            this.setState({
                submittingEmailRecommendation: false,
                displayCaptureEmailModal: false,
            });
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 2, uiFlow, distributionChannel)});
    }

    doRenderSlider = (printableOnly, stepsAmountsArr, value, recommendedValue, showWarning, onChange, onAfterChange) => {
        const localization = getLocalization(this.props.lang);
        const strings = localization.plan;
        const marks = {};

        const sliderStepsArr = [];
        stepsAmountsArr.forEach((e, idx) => {
            sliderStepsArr[idx] = idx+1; // rc-slider doesn't allow selecting 0
        })

        sliderStepsArr.forEach((step) => {
            const stepAmountsArrIdx = step - 1 ;
            if(printableOnly){
                if(step === value){
                    marks[step] = {
                        label: `$${formatMoneyAmount(stepsAmountsArr[stepAmountsArrIdx])}`
                    }
                }
            } else {
                marks[step] = {}
                if(step === value){
                    marks[step].label = <div className={'neutral900Text smaller'}><b>${formatMoneyAmount(stepsAmountsArr[stepAmountsArrIdx])}</b></div>;
                } else {
                    marks[step].label = `$${formatMoneyAmount(stepsAmountsArr[stepAmountsArrIdx])}`;
                }
            }
        });

        if (!!recommendedValue) {
            let recommendedValueIdx = 0;
            stepsAmountsArr.forEach((amount, idx)=>{
                if(amount === recommendedValue){
                    recommendedValueIdx = idx+1;
                }
            })
            let label = <div><div className={'neutral900Text smaller'}><b>${formatMoneyAmount(recommendedValue)}</b></div>{strings.recommended}</div>
            if(value !== recommendedValueIdx) {
                label = <div><div>${formatMoneyAmount(recommendedValue)}</div>{strings.recommended}</div>
            }
            marks[recommendedValueIdx] = {
                label: label,
            }
        }

        const min = stepsAmountsArr[0];
        value = value === null ? min : value;
        return <Slider
            className={`planChoiceSlider ${showWarning && 'warningSliderTrack'}`}
            onChange={onChange}
            onAfterChange={onAfterChange}
            min={1} max={stepsAmountsArr.length} step={1} dots={false} marks={marks}
            defaultValue={!!value ? value : min}
            value={value}
        />
    }

    renderSlider = (stepsArr, value, recommendedValue, showWarning, onChange, onAfterChange) => {
        return this.doRenderSlider(false, stepsArr, value, recommendedValue, showWarning, onChange, onAfterChange);
    }

    renderPrintableSlider = (stepsArr, value, recommendedValue, showWarning, onChange, onAfterChange) => {
        return this.doRenderSlider(true, stepsArr, value, recommendedValue, showWarning, onChange, onAfterChange)
    }

    renderCategoryExplanationModal = (strings) => {
        const {displayInformationAboutCategoriesModal} = this.state;
        const onModalClose = () => this.setState({displayInformationAboutCategoriesModal: false});
        return <Modal size={'tiny'} open={displayInformationAboutCategoriesModal} onClose={onModalClose}>
            <CustomModalHeader title={strings.categoryExp} onClose={onModalClose}/>
            <Modal.Content style={{maxHeight:'513px', overflowY: 'auto'}} className={"small"}>
                <CustomGrid>
                    <CustomGrid.Row columns={2} verticalAlign="middle">
                        <CustomGrid.Column width={4}>
                            <S3Image {...IMAGE.CONDITION_MODERATE_96PX}/>
                        </CustomGrid.Column>
                        <CustomGrid.Column width={8} style={{paddingLeft: 0}}>
                            <div className={"categoryModalTitleColor"}><b>{strings.moderate}</b></div>
                            <div className="small">{strings.descrM}</div>
                        </CustomGrid.Column>
                    </CustomGrid.Row>

                    <CustomGrid.Row columns={2} verticalAlign="middle">
                        <CustomGrid.Column width={4}>
                            <S3Image {...IMAGE.CONDITION_SEVERE_96PX}/>
                        </CustomGrid.Column>
                        <CustomGrid.Column width={8} style={{paddingLeft: 0}}>
                            <div className={"categoryModalTitleColor"}><b>{strings.severe}</b></div>
                            <div className="small">{strings.descrS}</div>
                        </CustomGrid.Column>
                    </CustomGrid.Row>

                    <CustomGrid.Row columns={2} verticalAlign="middle" style={{marginBottom: '30px'}}>
                        <CustomGrid.Column width={4} className={'noHorizontalPadding'}>
                            <S3Image {...IMAGE.CONDITION_CATASTROPHIC_96PX}/>
                        </CustomGrid.Column>
                        <CustomGrid.Column width={8} style={{paddingLeft: 0}}>
                            <div className={"categoryModalTitleColor"}><b>{strings.catastrophic}</b></div>
                            <div className="small">{strings.descrC}</div>
                        </CustomGrid.Column>
                    </CustomGrid.Row>
                </CustomGrid>
            </Modal.Content>
        </Modal>
    }

    renderSeeWhyWeChoseThisAmountsModal = (strings) => {
        const {displaySeeWhyWeChoseThisAmountsModal} = this.state;
        const onModalClose = () => this.setState({displaySeeWhyWeChoseThisAmountsModal: false});
        return <Modal open={displaySeeWhyWeChoseThisAmountsModal} size={'tiny'} onClose={onModalClose}>
            <CustomModalHeader title={strings.seeWhyWeChoseTitle} onClose={onModalClose}/>
            <Modal.Content style={{maxHeight:'513px', overflowY: 'auto'}} className={"small"}>
                <p>{strings.modalP1}</p>
                <p><b>{strings.modalP2Title}</b><br/>
                    {strings.modalP2}
                </p>

                <p><b>{strings.modalP3Title}</b><br/>
                    {strings.modalP3}
                </p>

                <p><b>{strings.modalP4Title}</b><br/>
                    {strings.modalP4}
                </p>

                <p><b>{strings.modalP5Title}</b><br/>
                    {strings.modalP5}
                </p>
            </Modal.Content>
        </Modal>
    }

    renderCaptureEmailModal = (strings) => {
        const {displayCaptureEmailModal, capturedEmail, emailValidationError, submittingEmailRecommendation} = this.state;
        const onModalClose = () => this.setState({displayCaptureEmailModal: false});
        return <Modal open={displayCaptureEmailModal} size={'tiny'} onClose={onModalClose}>
            <CustomModalHeader title={strings.emailMyRecommendation} onClose={onModalClose}/>
            <Modal.Content>
                {strings.emailMyRecommendationDescr}
                <Form style={{marginTop: '2em', marginBottom: '1em'}}>
                    <CustomEmailInput required value={capturedEmail}
                                onChange={(event, {value}) => {
                                    this.setState({capturedEmail: value});
                                }}
                    />
                </Form>
                <span style={{float: 'right', marginTop: '0.2em', marginBottom: '1em'}}>
                    <Button className={'emptyButton'} onClick={()=>this.setState({displayCaptureEmailModal: false})}>{strings.cancel}</Button>
                    <Button primary disabled={capturedEmail.length === 0 || !!emailValidationError || submittingEmailRecommendation} loading={submittingEmailRecommendation}
                            onClick={async () => await this.doSendEmailRecommendation(capturedEmail)}>
                        {strings.submit}
                    </Button>
                </span>
            </Modal.Content>
        </Modal>
    }

    getFilteredCoverOptions = () => {
        const {user, coverageOptions} = this.props;
        const {maritalStatus, dependents} = user;
        const coverOpts = coverageOptions.map(c => {
            return {key: c.key, text: c.text, value: c.value}
        });

        const MARRIED_ID = 1;
        const KIDS_UNDER_18 = 1;
        const KIDS_OVER_18 = 2;
        const NO_KIDS = 3;
        let filteredCoverOptions;
        if(maritalStatus === MARRIED_ID){
            if(dependents === NO_KIDS){
                filteredCoverOptions = coverOpts.filter((opts) => opts.value !== 'family' && opts.value !== 'child')
            } else {
                filteredCoverOptions = coverOpts;
            }
        } else {
            if(dependents === KIDS_UNDER_18 || dependents === KIDS_OVER_18){
                filteredCoverOptions = coverOpts.filter((opts) => opts.value !== 'family' && opts.value !== 'spouse')
            } else {
                filteredCoverOptions = coverOpts.filter((opts) => opts.value !== 'family' && opts.value !== 'spouse' && opts.value !== 'child')
            }
        }

        return filteredCoverOptions;
    }

    get sliderWarnings() {
        const {
            moderateIncrements,
            severeIncrements,
            catastrophicIncrements,
            moderateCoverageSelected,
            severeCoverageSelected,
            catastrophicCoverageSelected,
        } = this.props;

        const coverages = {
            moderate: moderateIncrements[moderateCoverageSelected - 1],
            severe: severeIncrements[severeCoverageSelected - 1],
            catastrophic: catastrophicIncrements[catastrophicCoverageSelected - 1]
        }

        return {
            moderate: coverages.severe < coverages.moderate,
            severe: (coverages.severe < coverages.moderate) || (coverages.catastrophic < coverages.severe),
            catastrophic: coverages.catastrophic < coverages.severe
        }
    }

    get hasWarnings() {
        return Object.values(this.sliderWarnings).some(e => e)
    }

    renderSliderWarnings() {
        if (!this.hasWarnings) return null

        const { lang } = this.props

        const localization = getLocalization(lang)
        const {
            sliderWarningLabel,
            sliderWarningDescription,
            moderate,
            severe,
            catastrophic
        } = localization.plan

        let vars;

        if (this.sliderWarnings.moderate && this.sliderWarnings.severe) {
            vars = {
                plan1: moderate,
                plan2: severe
            }
        } else {
            vars = {
                plan1: severe,
                plan2: catastrophic
            }
        }

        const description = stringTemplate(sliderWarningDescription, vars)

        return (
            <div className={'planChoiceWarningLabel smaller'}>
                <b>{sliderWarningLabel}</b> {description}
            </div>
        )
    }

    get hasRecommendation() {
        const {recommendationSkipped} = this.props;
        return !recommendationSkipped;
    }

    render() {
        const {stepProps, loading, loadingPersonalize, displayDontWantCoverageModal} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const {
            lang, employerContribution, cost, hasRiders,
            moderateIncrements, severeIncrements, catastrophicIncrements,
            isBenAdmin, costPerOption, costPerOptions, coverageOption, initialData,
            moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected,
            moderateCoverageRecommended, severeCoverageRecommended, catastrophicCoverageRecommended, user, isOpenEnrollment, openEnrollmentStarts,
            domesticPartnerEligible, civilUnionEligible
        } = this.props;
        let isPaperEnrollment = !!initialData.isPaperEnrollment;
        const localization = getLocalization(lang);
        const strings = localization.plan;
        const stringsAlsoIncludes = localization.yourBrellaPlanAlsoIncludes;
        const renaissanceLouisiana = isRenaissanceLouisiana(initialData);

        const infoIcon = <Icon className={'nonprintable planChoiceInfoIcon'} circular name={'info'}
                                    onClick={()=> this.setState({displayInformationAboutCategoriesModal: true})}/>;
        const paycheckOpt = !!costPerOptions && costPerOptions.filter((cpo) => cpo.value === "Paycheck")[0].id;
        const monthlyOpt = !!costPerOptions && costPerOptions.filter((cpo) => cpo.value === "Month")[0].id;

        let title = strings.title;
        let descriptionGreen = <ClickableText href onClick={() => this.setState({displaySeeWhyWeChoseThisAmountsModal: true})}>
            {strings.descriptionGreen}
        </ClickableText>;
        let description = <React.Fragment>{strings.basedOn}<br/><br/><span>{descriptionGreen}</span>{' '}{strings.getTips}</React.Fragment>

        if (!this.hasRecommendation) {
            title = strings.titleSkipped;
            descriptionGreen = <Link to={HEALTH_PLAN_DETAILS_ROUTE}><b>{strings.descriptionGreenSkipped}</b></Link>;
            description = <React.Fragment>{strings.descriptionSkipped}{' '}<span className={"descriptionText"}>{descriptionGreen}{'\u2192'}</span></React.Fragment>
        }

        const filteredCoverOptions = this.getFilteredCoverOptions();

        const paycheckInfo = <Icon className={'nonprintable planChoiceInfoIcon'} circular name={'info'}/>;
        const deductions = getNumberOfDeductions(initialData.payrollFrequencySelected);
        const paycheckTooltip = <Popup content={<span>{interpolateString(strings.paycheckInfo, [deductions])}</span>}
               style={{fontSize: '12px'}}
               trigger={paycheckInfo}/>

        const warningIcon = <Icon className={'planChoiceWarningIcon'} name='warning sign' />

        if (loading) {
            return <React.Fragment>
                <CustomGrid style={{marginTop: '-8em'}}>
                    <CustomGrid.Column textAlign={'center'} stretched>
                        <Container style={{marginTop: '10%'}}>
                            <S3Image {...IMAGE.LEVERS}/>
                            <Header as={'h4'}>{strings.justAMoment}</Header>
                            <p>{strings.jamDescr}</p>
                        </Container>
                    </CustomGrid.Column>
                </CustomGrid>
            </React.Fragment>;
        } else {
            const defaultSpouseDefinition = getSpouseEligibilityString(domesticPartnerEligible, civilUnionEligible, strings);
            const spouseDefinition = renaissanceLouisiana && defaultSpouseDefinition
                ? localization.tellUsAboutYou.partnerClarificationLouisiana
                : defaultSpouseDefinition;

            return (
                <React.Fragment>
                    {this.renderCategoryExplanationModal(strings)}
                    {this.renderSeeWhyWeChoseThisAmountsModal(strings)}
                    {this.renderCaptureEmailModal(strings)}
                    {!!displayDontWantCoverageModal && (
                        <IDontWantCoverageModal opened onModalClose={() => this.setState({displayDontWantCoverageModal: false})}/>
                    )}
                    <Container className={'contentContainer narrowContentContainer'}>
                        <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                        <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                            <CustomGrid.Column width={12} style={{paddingTop: 0}}>
                                <Container style={{padding: '1em 2rem 2rem'}}>
                                    <CustomGrid stackable>
                                        <CustomGrid.Row columns={1} centered>
                                            <CustomGrid.Column textAlign={'left'} width={12}>
                                                <Header as='h2' className={'printableTitle'}>{title}</Header>
                                                <p  className={'printableText'}>{description}</p>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>

                                        <PlanWarningsBanner />

                                        <CustomGrid.Row fitted={'vertically'}>
                                            <CustomGrid.Column width={8}>
                                                <b className={!isAnsel() && "primaryHeaderColor"}>{strings.iWantToCover}:</b>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>

                                        <CustomGrid.Row fitted={'vertically'}>
                                            <CustomGrid.Column textAlign={'left'} width={12}>
                                                <Form style={{ fontSize: '14px' }}>
                                                    {filteredCoverOptions.map((opt, idx)=>{
                                                        let text = opt.text;
                                                        if(opt.value === 'employee'){
                                                            text = strings.coverMySelf;
                                                        } else if(opt.value === 'spouse'){
                                                            if(renaissanceLouisiana){
                                                                text = strings.coverSpouseLouisiana;
                                                            } else if(civilUnionEligible || domesticPartnerEligible){
                                                                text = parseSingleUnderlinedWordInString(strings.coverSpouse);
                                                            } else {
                                                                text = strings.coverSpouse;
                                                            }
                                                        } else if(opt.value === 'child'){
                                                            text = parseSingleUnderlinedWordInString(strings.coverChild);
                                                        } else if(opt.value === 'family'){
                                                            text = strings.coverFamily;
                                                        }
                                                        let content = <Form.Field key={idx} className={'planCoverOptions'}>
                                                            <Radio key={idx} label={<label>{text}</label>} name='radioGroup'
                                                                    checked={coverageOption === opt.value}
                                                                    value={opt.value}
                                                                    onClick={async (e, {value}) => {
                                                                        const deletes = this.alterDependentInfoBasedOnCoverage(value);
                                                                        await this.setState({userModifiedData: true});
                                                                        await this.props.dispatch(setCoverageOption(value, deletes.deleteChildren, deletes.deleteSpouse));
                                                                        if(isAnsel()) {
                                                                            this.props.dispatch(setFetchPlanRecommendation(false));
                                                                        }
                                                                        this.personalizePlan().then();
                                                                    }}/>
                                                        </Form.Field>
                                                        if(opt.value === "child"){
                                                            content = <Popup key={idx} content={<span>{parseMultilineString(strings.childrenAreElegible)}</span>}
                                                                                style={{fontSize: '12px'}}
                                                                                trigger={content}/>
                                                        } else if(opt.value === "spouse" && spouseDefinition){
                                                            content = <Popup wide key={idx} content={<span>{spouseDefinition}</span>}
                                                                                style={{fontSize: '12px'}}
                                                                                trigger={content}/>
                                                        }
                                                        return content;
                                                    })}
                                                </Form>

                                                <div className="neutral700Text" style={{ marginTop: '1em', fontSize: '12px' }}>
                                                    {parseMultilineString(strings.dontSeeCoverageTier)}{' '}
                                                    <Link to={TELL_US_ABOUT_YOU_ROUTE}>{strings.goBackAndEdit}</Link>
                                                    {' '}{strings.yourFamilyDetails}
                                                </div>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>

                                        <CustomGrid.Row columns={2} centered style={{ padding: '1em 0 0 1em' }}>
                                            <CustomGrid.Column width={8}>
                                                <CustomGrid stackable>
                                                    <CustomGrid.Row>
                                                        <CustomGrid.Column className="small sliderHeader">{strings.moderate}{infoIcon}{this.sliderWarnings.moderate && warningIcon}</CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                    <CustomGrid.Row className={'nonprintable'} style={{ padding: '0 2rem' }}>
                                                        <CustomGrid.Column className='sliderRow'>
                                                            {this.renderSlider(moderateIncrements, moderateCoverageSelected, moderateCoverageRecommended, this.sliderWarnings.moderate, async (value) => {
                                                                await this.setState({userModifiedData: true});
                                                                await this.props.dispatch(setModerateCoverage(value));
                                                                this.props.dispatch(setFetchPlanRecommendation(false));
                                                            }, this.debouncedPersonalizePlan)}
                                                        </CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                    <CustomGrid.Row className={'printableOnly'}>
                                                        <CustomGrid.Column style={{marginBottom: '3em'}}>
                                                            {this.renderPrintableSlider(moderateIncrements, moderateCoverageSelected, moderateCoverageRecommended, this.sliderWarnings.moderate, async (value) => {
                                                                await this.setState({userModifiedData: true});
                                                                await this.props.dispatch(setModerateCoverage(value));
                                                                this.props.dispatch(setFetchPlanRecommendation(false));
                                                            }, this.debouncedPersonalizePlan)}
                                                        </CustomGrid.Column>
                                                    </CustomGrid.Row>

                                                    <CustomGrid.Row>
                                                        <CustomGrid.Column className="small sliderHeader">{strings.severe}{infoIcon}{this.sliderWarnings.severe && warningIcon}</CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                    <CustomGrid.Row className={'nonprintable'} style={{ padding: '0 2rem' }}>
                                                        <CustomGrid.Column className='sliderRow'>
                                                            {this.renderSlider(severeIncrements, severeCoverageSelected, severeCoverageRecommended, this.sliderWarnings.severe, async (value) => {
                                                                await this.setState({userModifiedData: true});
                                                                await this.props.dispatch(setSevereCoverage(value));
                                                                this.props.dispatch(setFetchPlanRecommendation(false));
                                                            }, this.debouncedPersonalizePlan)}
                                                        </CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                    <CustomGrid.Row className={'printableOnly'}>
                                                        <CustomGrid.Column style={{marginBottom: '3em'}}>
                                                            {this.renderPrintableSlider(severeIncrements, severeCoverageSelected, severeCoverageRecommended, this.sliderWarnings.severe, async (value) => {
                                                                await this.setState({userModifiedData: true});
                                                                await this.props.dispatch(setSevereCoverage(value));
                                                                this.props.dispatch(setFetchPlanRecommendation(false));
                                                            }, this.debouncedPersonalizePlan)}
                                                        </CustomGrid.Column>
                                                    </CustomGrid.Row>

                                                    <CustomGrid.Row>
                                                        <CustomGrid.Column className="small sliderHeader">{strings.catastrophic}{infoIcon}{this.sliderWarnings.catastrophic && warningIcon}</CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                    <CustomGrid.Row className={'nonprintable'} style={{ padding: '0 2rem' }}>
                                                        <CustomGrid.Column className='sliderRow'>
                                                            {this.renderSlider(catastrophicIncrements, catastrophicCoverageSelected, catastrophicCoverageRecommended, this.sliderWarnings.catastrophic, async (value) => {
                                                                await this.setState({userModifiedData: true});
                                                                await this.props.dispatch(setCatastrophicCoverage(value));
                                                                this.props.dispatch(setFetchPlanRecommendation(false));
                                                            }, this.debouncedPersonalizePlan)}
                                                        </CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                    <CustomGrid.Row className={'printableOnly'}>
                                                        <CustomGrid.Column style={{marginBottom: '3em'}} >
                                                            {this.renderPrintableSlider(catastrophicIncrements, catastrophicCoverageSelected, catastrophicCoverageRecommended, this.sliderWarnings.catastrophic, async (value) => {
                                                                await this.setState({userModifiedData: true});
                                                                await this.props.dispatch(setCatastrophicCoverage(value));
                                                                this.props.dispatch(setFetchPlanRecommendation(false));
                                                            }, this.debouncedPersonalizePlan)}
                                                        </CustomGrid.Column>
                                                    </CustomGrid.Row>
                                                </CustomGrid>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column width={4} style={{ marginBottom: '2rem' }}>
                                                <CustomGrid stackable>
                                                    <CustomGrid.Column>
                                                        <div className={'planChoiceRightBlock'}>
                                                            <div style={{marginBottom: '2em'}} className="small neutral700Text">
                                                                <div><b>{strings.employeeContrib}</b></div>
                                                                <Header as="h4" style={{margin: '0', fontSize: '24px'}}>
                                                                    {!!loadingPersonalize ? <Loader inline active size={'tiny'}/> :
                                                                    <React.Fragment>${cost}{initialData.payrollFrequencySelected === initialData.payrollFrequencyMonthly ? "/mo" : null}</React.Fragment>}
                                                                </Header>
                                                            </div>

                                                            {initialData.payrollFrequencySelected !== initialData.payrollFrequencyMonthly &&
                                                                <React.Fragment>
                                                                    <Form.Checkbox
                                                                        radio
                                                                        className="small neutral900Text"
                                                                        checked={costPerOption === paycheckOpt}
                                                                        onClick={async () => {
                                                                            await this.setState({userModifiedData: true});
                                                                            await this.props.dispatch(setCostPerOption(paycheckOpt));
                                                                            this.props.dispatch(setFetchPlanRecommendation(false));
                                                                            this.personalizePlan().then();
                                                                        }}
                                                                        label={<label>{strings.perPaycheck}{paycheckTooltip}</label>}
                                                                    />
                                                                    <Form.Checkbox
                                                                        radio
                                                                        className="small neutral900Text"
                                                                        checked={costPerOption === monthlyOpt}
                                                                        onClick={async () => {
                                                                            await this.setState({userModifiedData: true});
                                                                            await this.props.dispatch(setCostPerOption(monthlyOpt));
                                                                            this.props.dispatch(setFetchPlanRecommendation(false));
                                                                            this.personalizePlan().then();
                                                                        }} label={strings.monthly}
                                                                    />
                                                                </React.Fragment>
                                                            }

                                                            <Divider />

                                                            {!!employerContribution && employerContribution > 0 &&
                                                            <div style={{marginBottom: '1em'}} className="small neutral700Text">
                                                                <div className="smaller"><b>{strings.employerContrib}</b></div>
                                                                <b className={'primaryHeaderColor'}>
                                                                    {!!loadingPersonalize ?
                                                                        <Loader inline active size={'tiny'}/> :
                                                                        <React.Fragment>${employerContribution}{costPerOption === paycheckOpt ? ` / ${strings.paycheck}` : ` / ${strings.month}`}</React.Fragment>}
                                                                </b>
                                                            </div>}
                                                        </div>

                                                        {this.renderSliderWarnings()}
                                                    </CustomGrid.Column>
                                                </CustomGrid>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>

                                        {hasRiders &&
                                            <>
                                                <CustomDivider hidden />
                                                <CustomGrid.Row columns={1} className={'alsoIncludes'}  >
                                                    <CustomGrid.Column>
                                                        <Header as={'h3'}>
                                                            {isAIG() || isRenaissance() ? stringsAlsoIncludes.title : <>{STRATEGIC_PARTNER.LABEL}<span
                                                                className={'plusSignColor'}>+</span></>}
                                                        </Header>
                                                        <p>{stringsAlsoIncludes.yourBrellaPlan}{stringsAlsoIncludes.payoutListed}</p>
                                                    </CustomGrid.Column>
                                                </CustomGrid.Row>
                                                <CustomDivider hidden />
                                                <AdditionalRidersRows />
                                            </>
                                        }

                                        {(isBenAdmin || !isOpenEnrollment) && !isPaperEnrollment &&
                                            <React.Fragment>
                                                <div className={"nonprintable"} style={{height: '1em'}}/>
                                                <CustomGrid.Row style={{paddingBottom: 0}}>
                                                    <CustomGrid.Column>
                                                    <Header as={'h4'}>
                                                        {isBenAdmin && strings.readyToMakeYourSelec}
                                                        {!isBenAdmin && strings.nextSteps}
                                                    </Header>
                                                    {isBenAdmin && <p>{strings.goToYourEnrollmentPlat}</p>}
                                                    {!isBenAdmin && <p>{interpolateString(strings.yourOpenEnrollment, [openEnrollmentStarts])}</p>}
                                                    </CustomGrid.Column>
                                                </CustomGrid.Row>
                                                <CustomGrid.Row style={{paddingBottom: '.5em'}} className={"nonprintable"}>
                                                    <CustomGrid.Column>
                                                        <Icon name={'print'} className={'neutral700Text'}/>
                                                        <ClickableText
                                                            onClick={()=> {
                                                                registerPrintRecommendation(this.props.initialData.token);
                                                                window.print();
                                                            }} small>
                                                            {strings.printRecomm}
                                                        </ClickableText>
                                                    </CustomGrid.Column>
                                                </CustomGrid.Row>
                                                <CustomGrid.Row style={{paddingTop: 0}} className={"nonprintable"}>
                                                    <CustomGrid.Column>
                                                        <Icon name={'mail outline'} className={'neutral700Text'}/>
                                                        <ClickableText onClick={() => this.setState({displayCaptureEmailModal: true})} small>
                                                            {strings.emailRecomm}
                                                        </ClickableText>
                                                    </CustomGrid.Column>
                                                </CustomGrid.Row>
                                            </React.Fragment>
                                        }
                                    </CustomGrid>
                                </Container>
                            </CustomGrid.Column>
                        </CustomGrid>
                    </Container>
                    {(isBenAdmin || !isOpenEnrollment) && !isPaperEnrollment ? (
                        <Footer showTopFooter={false} showCenterData={true}/>
                    ) : (
                        <Footer
                            link={<span className={'small'}><b>{strings.or}</b>
                                <ClickableText onClick={() => this.setState({displayDontWantCoverageModal: true})}>
                                    {' '}{strings.iDontWant}</ClickableText></span>}
                            className={'nonprintable'}
                            showTopFooter={true} showCenterData={true}
                            buttonText={localization.next}
                            onClickCallback={() => {
                                handleSaveUserProgress(initialData.token, user).then();
                                this.props.history.push(this.props.nextRoute)
                            }}
                            disabled={!this.props.coverageOption || !this.props.costPerOption || this.hasWarnings}
                            loading={this.state.submitPlanLoading}/>
                    )
                    }
                </React.Fragment>
            )
        }
    }
}

export default withRouter(connect(mapStateToProps)(PlanChoice));
